import React from 'react';

export const cls = (...xs) => xs.filter(Boolean).join(' ');

export function Badge({ children }) {
  return (
    <span className="inline-flex items-center rounded-full border px-2 py-0.5 text-xs font-medium bg-white/5 border-white/10 text-white/80">
      {children}
    </span>
  );
}

export function Modal({ open, onClose, title, children, footer }) {
  if (!open) return null;
  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center">
      <div className="absolute inset-0 bg-black/50" onClick={onClose} />
      <div className="relative z-10 w-full max-w-xl rounded-2xl bg-[#111827] text-white shadow-2xl border border-white/10">
        <div className="flex items-center justify-between px-5 py-4 border-b border-white/10">
          <h3 className="text-lg font-semibold">{title}</h3>
          <button onClick={onClose} className="rounded-lg p-1 hover:bg-white/10">✕</button>
        </div>
        <div className="px-5 py-4">{children}</div>
        {footer ? <div className="px-5 py-4 border-t border-white/10">{footer}</div> : null}
      </div>
    </div>
  );
}

export function Drawer({ open, onClose, title, children, footer }) {
  return (
    <div className={cls('fixed inset-0 z-40', open ? '' : 'pointer-events-none')}>
      <div
        className={cls('absolute inset-0 transition', open ? 'bg-black/50' : 'bg-transparent')}
        onClick={onClose}
      />
      <div
        className={cls(
          'absolute right-0 top-0 h-full w-full max-w-5xl bg-[#0b1220] text-white shadow-2xl border-l border-white/10 transition-transform',
          open ? 'translate-x-0' : 'translate-x-full'
        )}
      >
        <div className="flex items-center justify-between px-6 py-4 border-b border-white/10">
          <h3 className="text-lg font-semibold">{title}</h3>
          <button onClick={onClose} className="rounded-lg p-1 hover:bg-white/10">✕</button>
        </div>
        <div className="h-[calc(100%-4rem)] overflow-y-auto p-6">{children}</div>
        {footer ? <div className="px-6 py-4 border-t border-white/10">{footer}</div> : null}
      </div>
    </div>
  );
}

export function LabeledInput({ label, ...props }) {
  return (
    <label className="grid gap-1">
      <span className="text-sm text-white/70">{label}</span>
      <input
        {...props}
        className={cls(
          'rounded-xl bg-white/5 border border-white/10 text-white px-3 py-2',
          'outline-none focus-visible:ring-2 focus-visible:ring-indigo-500/60'
        )}
      />
    </label>
  );
}

export function LabeledSelect({ label, children, ...props }) {
  return (
    <label className="grid gap-1">
      <span className="text-sm text-white/70">{label}</span>
      <select
        {...props}
        className={cls(
          'rounded-xl bg-white/5 border border-white/10 text-white px-3 py-2',
          'outline-none focus-visible:ring-2 focus-visible:ring-indigo-500/60'
        )}
      >
        {children}
      </select>
    </label>
  );
}
